@if (chemistry && chemistry.components?.length) {
  <mat-tree
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    class="example-tree"
  >
    <!-- This is the tree node template for leaf nodes -->
    <!-- There is inline padding applied to this node using styles.
        This padding value depends on the mat-icon-button width. -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <button
        class="tree-node-btn"
        [ngClass]="node.id === selected?.id ? 'active' : ''"
        (click)="setProductChemistry(node)"
      >
        <span class="tree-node-title">{{ node.articleName }}</span>
        @if (node.groupName) {
          <span
            class="tree-node-group-pill"
            [matTooltip]="
              translationService.getGroupInterchangeabilityTooltip()
            "
          >
            <mat-icon class="tree-node-group-icon">groups</mat-icon>
            <span class="tree-node-group-label">{{ node.groupName }}</span>
          </span>
        }
      </button>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <div class="mat-tree-node">
        <button
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + node.articleName"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        <button
          class="tree-node-btn"
          matTreeNodeToggle
          [ngClass]="node.id === selected?.id ? 'active' : ''"
          (click)="setProductChemistry(node)"
        >
          <span class="tree-node-title">{{ node.articleName }}</span>
          @if (node.groupName) {
            <span
              class="tree-node-group-pill"
              [matTooltip]="
                translationService.getGroupInterchangeabilityTooltip()
              "
            >
              <mat-icon class="tree-node-group-icon">groups</mat-icon>
              <span class="tree-node-group-label">{{ node.groupName }}</span>
            </span>
          }
          @if (isRoot(node)) {
            <mat-icon
              class="root-info-icon"
              [matTooltip]="
                translationService.getNavigationTreeDescriptionText()
              "
              >info</mat-icon
            >
          }
        </button>
      </div>
      <!-- There is inline padding applied to this div using styles.
              This padding value depends on the mat-icon-button width.  -->
      <div
        [class.example-tree-invisible]="!treeControl.isExpanded(node)"
        role="group"
      >
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
}
